<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Overview dashboard view for JB module with stats bar, running jobs section, next planned runs table, and recent runs widget
-->
@if (initialized) {
    <div class="grid mt-2">

        <!-- Section A: Stats Bar -->
        @if (stats?.length) {
            <div class="col-12">
                <div class="card p-3 shadow-1 border-round surface-0">
                    <div class="flex justify-content-between align-items-center">
                        @for (stat of stats; track stat.label; let first = $first) {
                            <div class="flex flex-column flex-1 justify-content-center surface-border pl-4"
                                 [class.border-left-1]="!first">
                                <div class="flex align-items-center">
                                    <i [class]="stat.icon + ' ' + stat.colorClass"></i>
                                    <small class="text-500 font-medium ml-2">{{ stat.label }}</small>
                                </div>
                                <div class="text-2xl font-bold mt-1">{{ stat.value }}</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Section B: Running Jobs (only when running) -->
        @if (runningJobs?.runningCount > 0) {
            <div class="col-12">
                <div class="card p-3 shadow-1 border-round surface-0">
                    <div class="flex align-items-center gap-2 mb-3">
                        <i class="fa-regular fa-spinner-third fa-spin text-blue-600"></i>
                        <span class="text-lg font-semibold">Aktuell laufende Jobs</span>
                        <span class="text-500">({{ runningJobs.runningCount }})</span>
                    </div>
                    <div class="flex flex-column gap-2">
                        @for (exec of runningJobs.executions; track exec.executionId) {
                            <div class="flex justify-content-between align-items-center p-3 surface-ground border-round">
                                <div class="flex align-items-center gap-3">
                                    <i class="fa-regular fa-spinner-third fa-spin text-blue-600"></i>
                                    <div>
                                        <div class="font-semibold">{{ exec.jobName }}</div>
                                        <div class="text-sm text-500">
                                            Laufzeit: {{ formatRuntime(runtimeCache.get(exec.executionId) || 0) }}
                                            @if (exec.currentStepName) {
                                                &middot; Schritt: {{ exec.currentStepName }}
                                            }
                                        </div>
                                    </div>
                                </div>
                                <p-button icon="fa-regular fa-circle-stop" severity="danger" [rounded]="true" [text]="true"
                                          pTooltip="Job stoppen"
                                          (click)="confirmStopJob($event, exec)">
                                </p-button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Section C: Next Planned Runs -->
        <div class="col-6">
            <div class="card p-3 shadow-1 border-round surface-0">
                <div class="flex justify-content-between align-items-center mb-3">
                    <span class="text-lg font-semibold">Nächste geplante Läufe</span>
                </div>
                @if (nextPlannedRuns?.length > 0) {
                    <p-table [value]="nextPlannedRuns" [scrollable]="true" scrollHeight="400px" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Name</th>
                                <th>Intervall</th>
                                <th>Nächster Lauf</th>
                                <th>Letzter Lauf</th>
                                <th>Status</th>
                                <th>Aktion</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-job>
                            <tr>
                                <td>{{ job.name }}</td>
                                <td>{{ getRecurrenceLabel(job.recurrenceUnit, job.recurrenceValue) }}</td>
                                <td>{{ job.nextScheduledRunTime | date:'dd.MM.yyyy HH:mm' }}</td>
                                <td>
                                    @if (job.lastRunStartTime) {
                                        {{ job.lastRunStartTime | date:'dd.MM.yyyy HH:mm' }}
                                    } @else {
                                        <span class="text-500">–</span>
                                    }
                                </td>
                                <td>
                                    <p-tag [value]="getExecutionStatusInfo(job.executionStatus).label"
                                           [severity]="getExecutionStatusInfo(job.executionStatus).severity">
                                    </p-tag>
                                </td>
                                <td>
                                    <p-button icon="fa-regular fa-play" severity="success" [text]="true" [rounded]="true"
                                              pTooltip="Jetzt ausführen"
                                              (click)="onRunNow(job)">
                                    </p-button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr><td colspan="6" class="text-center text-500">Keine geplanten Läufe</td></tr>
                        </ng-template>
                    </p-table>
                } @else {
                    <div class="text-center text-500 py-4">
                        <i class="fa-regular fa-calendar text-4xl mb-2"></i>
                        <p class="m-0">Keine geplanten Läufe</p>
                    </div>
                }
            </div>
        </div>

        <!-- Section D: Recent Runs Widget -->
        <div class="col-6">
            <div class="card shadow-1 border-round surface-0">
                <div class="p-3 pb-0">
                    <span class="text-lg font-semibold">Letzte Läufe (heute)</span>
                </div>
                @if (recentRunsWidget) {
                    <!-- AI: QL Widget table for JbJobRun with row-click navigation for today's runs -->
                    <mvs-widget [widgetData]="recentRunsWidget"
                                (onObjectSelect)="handleRunSelect($event)">
                    </mvs-widget>
                }
            </div>
        </div>

    </div>
}

<p-confirmDialog></p-confirmDialog>
